import { render, staticRenderFns } from "./parametretanitim.vue?vue&type=template&id=92d54880"
import script from "./parametretanitim.vue?vue&type=script&lang=js"
export * from "./parametretanitim.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports